module.exports = __webpack_public_path__ + "img/usa-infectious-diseases-male.ce867623.png";